export function isAValidHexColour(colour) {
    var regex = /^#([0-9A-F]{3}){1,2}$/i;
    return regex.test(colour);
}
export function isAValidRGBAColour(colour) {
    var regex = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(0(\.\d+)?|1(\.0+)?)\s*\)$/;
    return regex.test(colour);
}
export function isAValidColour(colour) {
    return isAValidHexColour(colour) || isAValidRGBAColour(colour);
}
function hexToRgb(hex) {
    var shortHexRegExp = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shortHexRegExp, function (_, r, g, b) { return r + r + g + g + b + b; });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) {
        console.warn('A valid HEX must be provided! Defaulting to white...');
        return {
            r: 255,
            g: 255,
            b: 255,
        };
    }
    else {
        return {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
        };
    }
}
export function setContrastColour(colour) {
    if (colour === undefined) {
        return '#FFFFFF';
    }
    var _a = hexToRgb(colour), r = _a.r, g = _a.g, b = _a.b;
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    if (yiq >= 128) {
        return '#000000';
    }
    else {
        return '#FFFFFF';
    }
}
